<template>
  <div class="ticket-description">
    <component
      v-for="(part, i) in parts"
      :is="part.type === 'link' ? 'a' : 'span'"
      :key="i"
      v-bind="part.type === 'link' ? linkAttrs(part.value) : {}"
      @click.stop
    >{{ part.value }}</component>
  </div>
</template>

<script>
export default {
  name: 'LinkifiedText',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    parts() {
      if (!this.text) return []

      const urlRegex = /(https?:\/\/[^\s<>"]+)/g
      const result = []
      let lastIndex = 0
      let match

      while ((match = urlRegex.exec(this.text)) !== null) {
        if (match.index > lastIndex) {
          result.push({ type: 'text', value: this.text.slice(lastIndex, match.index) })
        }

        let url = match[0]
        const trailing = url.match(/[.,;:!?)\]]+$/)
        const suffix = trailing ? trailing[0] : ''
        if (trailing) url = url.slice(0, -suffix.length)

        result.push({ type: 'link', value: url })
        if (suffix) result.push({ type: 'text', value: suffix })

        lastIndex = urlRegex.lastIndex
      }

      if (lastIndex < this.text.length) {
        result.push({ type: 'text', value: this.text.slice(lastIndex) })
      }

      return result
    }
  },
  methods: {
    linkAttrs(url) {
      return {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        class: 'text-primary'
      }
    }
  }
}
</script>

<style scoped>
.ticket-description {
  display: block;
  color: #575151;
  font-size: 17px;
  text-align: left;
  font-family: 'Lato', sans-serif;
  margin: 0 0 0 0.6rem;
  white-space: pre-line;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.text-primary {
  color: #1a73e8;
  transition: color 0.15s ease, text-decoration-color 0.15s ease;
  word-break: break-all;
  overflow-wrap: anywhere;
}

.text-primary:hover {
  color: #0d47a1;
  text-decoration-color: currentColor;
}

.text-primary:active {
  color: #08306b;
}

.text-primary:visited {
  color: #6a1b9a;
  text-decoration-color: rgba(106, 27, 154, 0.35);
}

.text-primary:visited:hover {
  color: #4a148c;
}

.text-primary:focus-visible {
  outline: 2px solid #1a73e8;
  outline-offset: 2px;
  border-radius: 2px;
}

</style>

